import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import WBSOAppFormView from 'views/WBSOApplicationForm/WBSOAppFormView'

const IntroPage = (props) => {
  return <WBSOAppFormView />
}

export const getServerSideProps = async ({ locale }) => {
  const translations = await serverSideTranslations(locale, [
    'application-intro',
  ])

  return {
    props: {
      ...translations,
    },
  }
}

export default IntroPage
